export const GAME_RULES_ROUTES = {
  TITLE: 'Game Rules',
  ABSOLUTE_PATH: '/game-rules',
  EXACT_PATH: '/game-rules',
};
